@if (!(chatClientService.panelOpen$ | async)) {
  <button
    type="button"
    class="chat-client-launcher btn btn-primary rounded-circle border-0 shadow d-flex align-items-center justify-content-center p-0 text-white position-fixed"
    (click)="openChat($event)"
    aria-label="Open chat"
  >
    <i class="bi bi-chat-dots-fill fs-4" aria-hidden="true"></i>
  </button>
}

@if (chatClientService.panelOpen$ | async) {
  <div
    class="box-chat-client position-fixed d-flex flex-column overflow-hidden bg-white rounded-4"
    role="dialog"
    aria-label="Chat"
  >
    <div class="box-chat-client-body position-relative flex-fill">
      @if (chatClientService.loading$ | async) {
        <div
          class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white"
        >
          <div class="spinner-border text-primary" role="status"></div>
        </div>
      }
      @if (safeIframeUrl$ | async; as chatUrl) {
        <iframe
          class="w-100 h-100 border-0 d-block"
          [src]="chatUrl"
          title="Chat"
          [class.d-none]="chatClientService.loading$ | async"
        ></iframe>
      }
    </div>
  </div>
}
